<a [href]="url" target="_blank" aria-describedby="linkOpensInNewTab" *ngFor="let url of images">
    <img [src]="url" alt="{{ 'affected image' | translate }}" class="img-responsive img-thumbnail">
</a>
